package com.eladfinish.bible.contest.screens.names

import androidx.compose.runtime.Composable
import androidx.compose.runtime.Immutable
import androidx.compose.runtime.Stable
import androidx.compose.ui.text.AnnotatedString
import com.eladfinish.bible.contest.arch.ActionKt
import com.eladfinish.bible.contest.arch.EffectKt
import com.eladfinish.bible.contest.arch.StateKt
import com.eladfinish.bible.contest.data.ChapterData
import com.eladfinish.bible.contest.screens.names.data.Gender
import com.eladfinish.bible.contest.screens.names.data.InternalNameLink
import com.eladfinish.bible.contest.screens.names.data.NameItem
import com.eladfinish.bible.contest.screens.names.data.NameReference
import dev.icerock.moko.resources.compose.localized
import dev.icerock.moko.resources.desc.StringDesc
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.toImmutableList

@Immutable
data class NamesState(
    val isLoading: Boolean,
    val genderList: ImmutableList<Gender>,
    val alephBet: StringDesc,
    val letterLines: Int,
    val selectedGender: Gender,
    val selectedLetter: Char?,
    val annotatedString: AnnotatedString,
    val nameList: ImmutableList<NameItem>,
    val dialogState: DialogState,
) : StateKt {

    val alephBetAsList: ImmutableList<Char>
        @Composable
        get() = alephBet.localized().toImmutableList()

    @Stable
    sealed class DialogState {
        data class MenuDialog(
            val name: String,
            val nameReferences: List<NameReference>,
        ) : DialogState()

        data class ChapterDialog(
            val chapterData: ChapterData,
        ) : DialogState()

        data object None : DialogState()
    }
}

sealed class NamesAction : ActionKt {
    data class GenderSelected(val gender: Gender) : NamesAction()
    data class LetterSelected(val letter: Char) : NamesAction()
    data class BrowseSelected(val name: String, val nameReferences: List<NameReference>) : NamesAction()
    data class NameReferenceSelected(val name: String, val nameReference: NameReference) : NamesAction()
    data class InternalLinkClicked(val internalNameLink: InternalNameLink) : NamesAction()
    data class OnItemCopied(val text: String) : NamesAction()
    data object HideDialog : NamesAction()
}

sealed class NamesEffect : EffectKt {
    data object ItemsLoaded : NamesEffect()
    data object NoNameFound : NamesEffect()
    data object NoInternet : NamesEffect()
    data class ScrollToItem(val index: Int) : NamesEffect()
}
